import { useContext } from "react";
import IsMainContentContext from "../../../../../../context/IsMainContentContext";
import { FormattedAirDate } from "../../../../../VideoUtils/components/FormattedDate/component";
import VideoTimeLabel from "../../../../../VideoUtils/components/VideoTimeLabel/component";
import { getIsLiveStream } from "../../../../../../utils/dataTransform/ContentItem/library";
import {
    getVideoPlaceholderImageProps,
    getVideoPlaceholderPlayBtn,
} from "./utils";
import { VIDEO_ASPECT_RATIOS } from "../../../../constants";

const DefaultVideoUI = ({
    isPlaceholderHidden,
    mediaItem,
    onClick,
    imageOverride,
    noPlaceholderKeyboardNav,
} = {}) => {
    const { image, media, publishedAt, title } = mediaItem;

    const isMain = useContext(IsMainContentContext);
    const imgLoadPriority = isMain ? "eager" : "lazy";

    let imgProps, aspectRatio;
    if (imageOverride?.url) {
        imgProps = { src: imageOverride.url };
        aspectRatio = VIDEO_ASPECT_RATIOS[imageOverride.aspectRatio];
    } else {
        imgProps = getVideoPlaceholderImageProps(image);
    }

    const timestamp = parseInt(publishedAt);
    const isLive = getIsLiveStream(media?.streamType);
    const isLiveNow = isLive && timestamp < Date.now();
    const itemTitle = title ?? "";
    const mediaDuration = isLive ? 0 : media?.duration;

    const isHiddenClass = isPlaceholderHidden ? " hidden" : "";

    return (
        <div
            className="player-placeholder-video-ui"
            data-testid="player-placeholder-video-ui"
            title={itemTitle}
            style={{ "--aspect-ratio": aspectRatio }}
            {...(!noPlaceholderKeyboardNav && {
                role: "button",
                tabIndex: 0,
                onClick: onClick,
                onKeyPress: onClick,
            })}
        >
            <div className="player-placeholder">
                {/* player will be injected here */}
            </div>
            <div className={`player-placeholder-ui${isHiddenClass}`}>
                <div
                    className={`video-item video-card-overlay`}
                    title={itemTitle}
                >
                    <div className="thumbnail-wrapper">
                        <img
                            src={imgProps.src}
                            srcSet={imgProps.srcSet}
                            sizes={imgProps.sizes}
                            alt=""
                            className="thumbnail"
                            loading={imgLoadPriority}
                            data-testid="thumbnail-image"
                        />
                    </div>
                    <div className="video-card-overlay-container">
                        <div className="video-info-container">
                            <p className="video-item-title">{itemTitle}</p>
                            <div className="video-time-container">
                                <div className="play-button-container">
                                    {getVideoPlaceholderPlayBtn()}
                                </div>
                                {(!isLive || isLiveNow) && (
                                    <FormattedAirDate
                                        classes="video-time-stamp"
                                        airDate={timestamp}
                                        includeSeconds={true}
                                        ariaHidden={false}
                                        isLive={isLive}
                                    />
                                )}
                                <VideoTimeLabel
                                    videoDuration={mediaDuration}
                                    videoAirDate={timestamp}
                                    captions={media?.hasCaptions}
                                    isLive={isLive}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DefaultVideoUI;
